// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"ClientsList_pageHeader__4a08u","playersList":"ClientsList_playersList__3keyv","playersListItem":"ClientsList_playersListItem__3yll_"};